import { useState, useEffect, useCallback } from "react";
import { ENDPOINT } from "../../../../constants/endpointConstants";
import {
  getToken,
  formatDateTime,
  getRangeDates,
} from "../../../../utils/utils";
import axios from "axios";

const InsightCategories = ({ startDate, endDate }) => {
  const [categoriesData, setCategoriesData] = useState(null);
  const [categoriesList, setCategoriesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");

  const getCategoriesData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
        startDate,
        endDate
      );
      const requestBody = {
        startDate: formatDateTime(dateInitFormatted),
        endDate: formatDateTime(dateFinishFormatted),
      };

      if (selectedCategory) {
        requestBody.categoryIds = [parseInt(selectedCategory)];
      }

      const { data } = await axios.post(
        ENDPOINT.POST_SALES_BY_CATEGORY,
        requestBody,
        token
      );

      setCategoriesData(data);
    } catch (err) {
      setError("Error al cargar datos de categorías");
      console.error("Error fetching categories data:", err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, selectedCategory]);

  useEffect(() => {
    getCategoriesList();
  }, []);

  useEffect(() => {
    if (startDate && endDate && selectedCategory) {
      getCategoriesData();
    }
  }, [startDate, endDate, selectedCategory, getCategoriesData]);

  const getCategoriesList = async () => {
    setLoadingCategories(true);

    try {
      const token = getToken();
      const { data } = await axios.get(ENDPOINT.GET_PRODUCT_CATEGORIES, token);

      setCategoriesList(data);
    } catch (err) {
      console.error("Error fetching categories list:", err);
    } finally {
      setLoadingCategories(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }).format(value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  if (loadingCategories) {
    return (
      <div className="insight-loading">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando categorías...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="categories-content">
      <div className="category-dropdown">
        <select
          className="form-select cashier-select"
          value={selectedCategory}
          onChange={handleCategoryChange}
        >
          <option value="" disabled>
            Seleccione una categoria
          </option>
          {categoriesList.map((category, index) => (
            <option value={category.id} key={index}>
              {category.name}
            </option>
          ))}
        </select>
      </div>

      {selectedCategory && (
        <div className="categories-data">
          {loading && (
            <div className="insight-loading">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando datos...</span>
              </div>
            </div>
          )}

          {error && (
            <div className="insight-error">
              <p className="text-danger mb-0">{error}</p>
            </div>
          )}

          {!loading &&
            !error &&
            categoriesData &&
            categoriesData.categories &&
            categoriesData.categories.length > 0 && (
              <div className="categories-list mt-3">
                {categoriesData.categories.map((category) => (
                  <div key={category.categoryId} className="category-item">
                    <div className="category-info text-center d-flex flex-column gap-2">
                      <p className="fw-bold mb-1">
                        Cantidad:{" "}
                        <span className="fw-light">{category.totalAmount}</span>
                      </p>
                      <p className="fw-bold mb-1">
                        Valor:{" "}
                        <span className="fw-light">
                          {formatCurrency(category.totalRevenue)}
                        </span>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}

          {!loading &&
            !error &&
            (!categoriesData ||
              !categoriesData.categories ||
              categoriesData.categories.length === 0) && (
              <div className="insight-empty">
                <p className="text-muted mb-0">
                  No hay datos disponibles para la categoría seleccionada
                </p>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default InsightCategories;
